import { Map, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

export const FETCH_JOB_INPUT_ITEM_TABLE_DATA =
  'jobInputsAdmin/FETCH_JOB_INPUT_ITEM_TABLE_DATA'
export const [
  FETCH_JOB_INPUT_ITEM_TABLE_DATA_SUCCESS,
  FETCH_JOB_INPUT_ITEM_TABLE_DATA_FAILURE,
] = [
  `${FETCH_JOB_INPUT_ITEM_TABLE_DATA}_SUCCESS`,
  `${FETCH_JOB_INPUT_ITEM_TABLE_DATA}_FAILURE`,
]

export const JOB_INPUT_ITEMS_CLEAR_STORE =
  'jobInputsAdmin/JOB_INPUT_ITEMS_CLEAR_STORE'

export const fetchJobInputItemData = ActionHelper.createActionObj(
  FETCH_JOB_INPUT_ITEM_TABLE_DATA,
)
export const jobInputItemsClearStore = ActionHelper.createActionObj(
  JOB_INPUT_ITEMS_CLEAR_STORE,
)

const initialState = () =>
  fromJS({
    isLoadingTableData: false,
    tableData: Map({}),
  })

const jobInputItemsAdmin = handleActions(
  {
    [FETCH_JOB_INPUT_ITEM_TABLE_DATA]: state =>
      state.set('isLoadingTableData', true),
    [FETCH_JOB_INPUT_ITEM_TABLE_DATA_SUCCESS]: (state, action) =>
      state
        .set('isLoadingTableData', false)
        .set('tableData', Map(action.payload)),
    [FETCH_JOB_INPUT_ITEM_TABLE_DATA_FAILURE]: state =>
      state
        .set('isLoadingTableData', false)
        .set('tableData', initialState().get('tableData')),
    [JOB_INPUT_ITEMS_CLEAR_STORE]: () => initialState(),
  },
  initialState(),
)

export default jobInputItemsAdmin
